export default "__VITE_ASSET__05845712__"